/// <amd-module name="VSSUI/Components/IdentityCard/DefaultAbridgedCard" />
import * as React from "react";
import * as Resources from "VSSUI/Resources.Persona";
import { Persona } from "../Persona/Persona";
import { PersonaSize } from "../Persona/Persona.Props";
import { CardContactLine } from "./CardContactLine";
import { IContactCardProps } from "./ContactCard.Props";

function verifySignInAddress(signInAddress?: string): boolean {
    if (!signInAddress) {
        return false;
    }

    // this is copied from System.ComponentModel.DataAnnotations.EmailAddressAttribute
    const PROFILE_EMAIL_ADDRESS_PATTERN: RegExp = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i;

    if (PROFILE_EMAIL_ADDRESS_PATTERN.test(signInAddress)) {
        return true;
    }

    return false;
}

export const DefaultAbridgedCard: React.FunctionComponent<IContactCardProps> = (props: IContactCardProps) => {
    const { displayName, signInAddress } = props.identity;

    return (
        <div className="bolt-default-card-abridged flex-column scroll-hidden">
            <div className="flex-row">
                <Persona className="bolt-identity-card-persona-main" size={PersonaSize.size72} identity={props.identity} />
                <div className="flex-column flex-grow bolt-identity-card-name scroll-hidden">
                    <div className="word-wrap title-s">{displayName}</div>
                </div>
            </div>
            {verifySignInAddress(signInAddress) && (
                <div className="flex-column scroll-hidden">
                    <div className="bolt-identity-default-card-info-wrapper">
                        <hr className="bolt-identity-card-hr" />

                        <div className="bolt-identity-default-card-header-wrapper">
                            <b>{Resources.IdentityCardContact}</b>
                        </div>
                    </div>

                    <div className="bolt-identity-default-card-contact-info-container">
                        <CardContactLine iconName="Mail" hiddenLabel={Resources.IdentityCardEmail} content={signInAddress} link={`mailto:${signInAddress}`} />
                        <CardContactLine iconName="Chat" content={Resources.IdentityCardStartChat} link={`sip:${signInAddress}`} />
                    </div>
                </div>
            )}
        </div>
    );
};
